import { Controller } from "@hotwired/stimulus"

// Lives on the expiration cleanup confirmation modal. Broadcasts the user's
// keep/remove choice to the expiration-cleanup controller on the field
// properties form, which sits outside the modal frame.
export default class extends Controller {
  static targets = ["radio"]
  static values = { fieldId: String }

  submit() {
    const checked = this.radioTargets.find((radio) => radio.checked)

    this.dispatch("choice", {
      target: window,
      detail: { fieldId: this.fieldIdValue, remove: checked?.value === "true" },
    })
  }
}
